import { forwardRef } from "react";
import { cn } from "@/lib/cn";

export const Label = forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  function Label({ className, ...props }, ref) {
    return (
      <label
        ref={ref}
        className={cn("mb-[.4rem] block text-sm text-muted-foreground", className)}
        {...props}
      />
    );
  },
);

export const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          "w-full rounded-lg border border-border bg-background px-[.9rem] py-[.8rem] text-foreground outline-none focus:border-primary",
          className,
        )}
        {...props}
      />
    );
  },
);

/**
 * The message under a field.
 *
 * `role="alert"` because it appears after a submit — a validation message that
 * only exists visually is not there at all for somebody who cannot see the
 * field turn red.
 */
export function FieldError({ children }: { children?: React.ReactNode }) {
  if (!children) return null;

  return (
    <p role="alert" className="mt-[.4rem] text-sm text-primary">
      {children}
    </p>
  );
}
